import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import TestMCQ from "./TestMCQ";


const TestMCQPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--test">
        <SideBar />
        <TestMCQ />
      </div>
    </main>
  );
};

export default TestMCQPage;
